import React from 'react'
import styled from 'styled-components'
import { Logo } from './index'
import { colors } from '../theme'

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
`

const Spinner = styled.div`
  margin-top: 2rem;
  width: 40px;
  height: 40px;
  border: 3px solid ${colors.background};
  border-top: 3px solid ${colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const LoadingScreen: React.FC = () => {
  return (
    <LoadingWrapper>
      <Logo big />
      <Spinner />
    </LoadingWrapper>
  )
}

export default LoadingScreen
